// Draws the amber "move ribbon" across the centre gutter — an SVG bézier from
// each move's origin marker to its destination block. Position math is live so
// it survives resize/wrap; the caller re-invokes on resize. Honours
// prefers-reduced-motion (skips the draw animation).
const cleanups = new WeakMap();
const SVG_NS = 'http://www.w3.org/2000/svg';

export function drawRibbons(svg, container, pairs) {
  cleanups.get(svg)?.();
  const cleanup = [];
  cleanups.set(svg, () => cleanup.forEach(fn => fn()));
  svg.innerHTML = '';
  if (!pairs || !pairs.length) return;

  const card = container.getBoundingClientRect();
  svg.setAttribute('viewBox', `0 0 ${card.width} ${card.height}`);
  const reduce = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;

  for (const { from, to, interactive } of pairs) {
    const a = container.querySelector(from);
    const b = container.querySelector(to);
    if (!a || !b) continue;

    const ar = a.getBoundingClientRect();
    const br = b.getBoundingClientRect();
    const x1 = ar.right - card.left;
    const y1 = ar.top - card.top + ar.height / 2;
    const x2 = br.left - card.left;
    const y2 = br.top - card.top + br.height / 2;
    const midx = (x1 + x2) / 2;

    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', `M ${x1} ${y1} C ${midx} ${y1}, ${midx} ${y2}, ${x2} ${y2}`);
    if (!reduce) path.classList.add('draw');
    svg.appendChild(path);

    const dot = document.createElementNS(SVG_NS, 'circle');
    dot.setAttribute('cx', x2);
    dot.setAttribute('cy', y2);
    dot.setAttribute('r', '3.5');
    svg.appendChild(dot);
    if (interactive || pairs.length > 4) {
      path.classList.remove('draw');
      const update = () => {
        const visible = [a, b].some(el => el.matches(':hover') || el === el.ownerDocument.activeElement);
        path.style.display = dot.style.display = visible ? '' : 'none';
      };
      for (const el of [a, b]) {
        for (const event of ['mouseenter', 'mouseleave', 'focus', 'blur']) {
          el.addEventListener(event, update);
          cleanup.push(() => el.removeEventListener(event, update));
        }
      }
      update();
    }
  }
}
